import bundledMarkUrl from "../../../../docs/brand/andrew-head.png";

export const appName = import.meta.env.VITE_APP_NAME || "Andrew Intelligence";
// Older private builds supplied this untracked public file. Bundle the existing
// shared brand asset so clean checkouts and release archives retain the mark.
const configuredMark = import.meta.env.VITE_APP_MARK_URL;
export const appMarkUrl =
  configuredMark && configuredMark !== "/brand-head.png" ? configuredMark : bundledMarkUrl;
export const docsUrl =
  import.meta.env.VITE_DOCS_URL ||
  "https://github.com/digitaldetour/andrew-intelligence/blob/andrew-intelligence/docs/README.md";

export const welcomeMessage = import.meta.env.VITE_WELCOME_MESSAGE || "";
